"use client";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import HeroSection from './components/HeroSection';
import FeaturedProperties from './components/FeaturedProperties';
import PopularCities from './components/PopularCities';
import CuratedCollections from './components/CuratedCollections';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import SellRentBanner from './components/SellRentBanner';
import AppDownload from './components/AppDownload';
import HighlightServices from './components/HighlightServices';

export default function Home() {
    return (
        <>
            <Navbar />
            <main className='bg-gray'>
                <HeroSection />
                <HighlightServices />
                <PopularCities />
                {/* <FeaturedProperties /> */}
                <CuratedCollections />
                <SellRentBanner />
                <Services />
                <WhyChooseUs />
                <AppDownload />
            </main>
            <Footer />
        </>
    );
}
